/*
 * @Description: 报警联系人 api
 * @Author: lidan
 * @Date: 2020-08-17 10:06:26
 * @LastEditors: lidan
 * @LastEditTime: 2020-08-17 11:20:23
 */
import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_E6YUN_BASE_WEB = "",
  E6_MS_TMS_BASE_WEB = ""
} = e6ModuleBaseDataApi;

//********************* 报警联系人管理 ****************** */

// 获取报警联系人管理列表数据
export function findAlarmContactsByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/alarmContact/findAlarmContactsByPage/page`,
    method: "post",
    data
  });
}
//新增报警联系人信息
export function saveAlarmContact(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/alarmContact/save`,
    method: "post",
    data
  });
}
//修改报警联系人信息
export function updateAlarmContact(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/alarmContact/update`,
    method: "post",
    data
  });
}

//查询报警联系人详细信息
export function getInfoAlarmContact(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/alarmContact/findAlarmContactById`,
    method: "get",
    params
  });
}
//删除报警联系人信息
export function deleteAlarmContacts(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/alarmContact/deleteAlarmContacts`,
    method: "post",
    data
  });
}

// 报警联系人姓名唯一性校验
export function checkName(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/alarmContact/checkName`,
    method: "get",
    params
  });
}

// 报警联系人手机号唯一性校验
export function checkPhone(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/alarmContact/checkPhone`,
    method: "get",
    params
  });
}

// 报警联系人邮箱唯一性校验
export function checkEmail(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/alarmContact/checkEmail`,
    method: "get",
    params
  });
}

// 导出报警联系人信息
export function exportAlarmContacts(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_BASE_WEB}/alarmContact/exportAlarmContacts`,
    method: "post",
    data
  });
}

//(下拉框)查询所属部门信息
export function findOrganizationTreeAlarmContact() {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/e6Organization/findOrganizationTree`,
    method: "get"
  });
}
